<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <!-- <v-btn v-if=" selected.length > 1" text @click="deleteUser" color="red">Delete Users</v-btn> -->
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          Users
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          item-key="iduser"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="users"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">New User</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }} : {{ editedItem.username }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        

                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model="editedItem.username" suffix="" label="Username"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model="editedItem.password" suffix="" label="Password"></v-text-field>
                        </v-col>
                        

                      </v-row>
                      <v-row>
                       <v-col cols="12" md="12" sm="12">
                          <v-text-field v-model="editedItem.email" suffix="" label="Email"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model="editedItem.first_name" suffix="" label="First Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model="editedItem.last_name" suffix="" label="Last Name"></v-text-field>
                        </v-col>

                                                <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model="editedItem.company" suffix="" label="Company"></v-text-field>
                        </v-col>

                                                <v-col cols="12" md="6" sm="6">
                          <v-text-field v-model="editedItem.discount" suffix="%" label="Discount"></v-text-field>
                        </v-col>
                         
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
        </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    dialog: false,
    selected: [],
    editUserId: 100,
    search: "",
    users: [],
    headers: [
      {
        text: "Username",
        align: "left",
        sortable: true,
        value: "username"
      },
      // { text: "Password", value: "password" },
      { text: "First Name", value: "first_name" },
      { text: "last_name", value: "last_name" },
      { text: "E-mail", value: "email" },
      { text: "Discount (%)", value: "discount" },
      { text: "Company", value: "company" },
      { text: "Creation", value: "create_time" },
      // { text: "NPSHR", value: "updated_time" },
      { text: "Actions", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      iduser: -1,
      username: "",
      email: "",
      password: null,
      create_time: "",
      updated_time: "",
      lastname: "",
      firstname: "",
      discount: 0.0,
    },
    defaultItem: {
      iduser: -1,
      username: null,
      email: "",
      password: null,
      create_time: "",
      updated_time: "",
      lastname: "",
      firstname: "",
      discount: 0.0,
    },
     
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
     
  },

  watch: { 
    dialog(val) {
      val || this.close();
    },
     
  },

  // created () {
  //     this.initialize()
  //   },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchUsers();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.selected = [item];
      this.deleteUser();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        // Object.assign(this.users[this.editedIndex], this.editedItem);
        this.saveUser(true, this.editedItem);
      } else {
        // save new
        // this.users.push(this.editedItem);
        this.saveUser(false, this.editedItem);
      }
    },

    deleteUser: function() {
      confirm("Are you sure you want to delete this item?") &&
        this.selected.forEach(this.deleteDataRequest);
      this.selected = [];
      console.log("selected bosaltildi.");
    },
    deleteDataRequest: function(user) {
      this.$http
        .get(this.$API_URL + "user-delete?iduser=" + user.iduser)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchUsers();
        });
    },
    fetchUsers: function() {
      this.$http.get(this.$API_URL + "users" ).then(result => {
        this.users = result.data;
      });
    },
 
    saveUser: function(isUpdate, item) {
      var targetUrl = isUpdate == false ? "save_user" : "update_user";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: item
      })
        .then(response => {
          // console.log(response.data);
          if (response.data == "1")
          this.close();

          this.fetchUsers()
            
          // if (response.data == "1")
          //  window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
